module.exports = __webpack_public_path__ + "static/media/icici-bank-logo.608ebd79.png";